export const URLS = {
  IMPORT_PRODUCTS_MODEL: `${process.env.VUE_APP_BASE_URL}storage/imports/modelo-importacao-produtos.xlsx`,
  IMPORT_POINTS_MODEL: `${process.env.VUE_APP_BASE_URL}storage/imports/modelo-importacao-pontos.xlsx`,
  IMPORT_CARDS_MODEL: `${process.env.VUE_APP_BASE_URL}storage/imports/modelo-importacao-cartoes.xlsx`,
  IMPORT_CLIENTS_MODEL: `${process.env.VUE_APP_BASE_URL}storage/imports/modelo-importacao-de-clientes.xlsx`,
  IMPORT_SALES_MODEL: `${process.env.VUE_APP_BASE_URL}storage/imports/modelo-importacao-de-vendas.xlsx`,
};
